import { useMemo } from 'react'

/**
 * Hook to get URL query parameters
 * Caches the URLSearchParams instance to avoid recreation on every call
 */
export const useQueryParams = () => {
    return useMemo(() => new URLSearchParams(window.location.search), [])
}

/**
 * Get a specific query parameter value
 */
export const useQueryParam = (key: string): string | null => {
    const params = useQueryParams()
    return params.get(key)
}

export default useQueryParams
